import { type ClientLogger } from '@landsbankinn/client-logger';
import { ConsoleLoggerService } from './ConsoleLoggerService';
import { SentryLoggerService } from './SentryLoggerService';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ILoggerService extends ClientLogger {}

export class LoggerServiceFactory {
  static create(prefix: string): ILoggerService {
    return import.meta.env.VITE_SENTRY_DSN
      ? new SentryLoggerService(
          {
            'idp.ui.service': prefix,
          },
          {
            allowTraceLoggingInSentry:
              import.meta.env.VITE_SENTRY_ALLOW_TRACE_LOGS === 'true',
            logLevel: import.meta.env.VITE_LOG_LEVEL as
              | 'trace'
              | 'info'
              | 'warn'
              | 'error'
              | undefined,
          },
        )
      : new ConsoleLoggerService(prefix);
  }
}
